import Report from '@xpeng/report-js'
import { getClientEnv } from './common'

let reporter: Report = null;

const APPID = 'J001';
const SO = 'J001005';

/**
 * 获取链接参数
 * @param url 链接
 * @param name 参数名称
 */
function getUrlParameter(url: string, name: string) {
  const regexSearch = "[\\?&#]" + name + "=([^&#]*)";
  const regex = new RegExp(regexSearch);
  const results = regex.exec(url);
  return results ? window.decodeURIComponent(results[1]) : '';
}

const envMap = {
  dev: 'test',
  test: 'test',
  pre: 'pre',
  production: 'production',
};

// 初始化埋点组件
(function initReporter() {
  const ch = getUrlParameter(window.location.href, 'ch');
  // console.error('初始化埋点组件中。。。', ch, reporter);
  // console.error('getClientEnv() ???? ', getClientEnv());
  if (reporter) {
    return reporter;
  }
  reporter = new Report(
    {
      appid: APPID,
      so: SO,
      // mcode,
      // pa,
      type: 'event',
      ch,
      // ...padData
    },
    { env: envMap[getClientEnv()] || 'production' }
  )
})()

// 异步发送埋点消息
export function sendReport(data, immediate: boolean = false) {
  console.log('异步发送埋点消息中。。。', reporter, data);
  if (!reporter) return;

  if (immediate) {
    reporter.send(data);
    return;
  }
  setTimeout(() => {
    reporter.send(data);
  }, 0);
}

/**
 * 埋点上报
 * @param appid 业务id
 * @param so 打点业务方
 * @param ch 渠道来源，多级渠道来源用"_"分隔
 * @param mcode 日志类型代码
 * @param pa 业务自定义参数
 * @param ut 用户类型： 1-潜客， 2-预定车主， 3-车主
 * @param type 类型： 页面曝光-page， 页面元素曝光-element， 事件-event
 */
export async function reportUserBehavior(
  { appid = 'J001', so, mcode, pa='' ,ch = '' },
  type = 'event'
) {

  let padData = {}

  const report = new Report(
    {
      appid,
      so,
      mcode,
      pa,
      ch,
      ...padData
    },
    { env: getClientEnv() }
  )

  report.send({ type })
}
